export const discountGroupConstants = {
  GETALL_REQUEST: 'DISCOUNT_GROUPS_GETALL_REQUEST',
  GETALL_SUCCESS: 'DISCOUNT_GROUPS_GETALL_SUCCESS',
  GETALL_FAILURE: 'DISCOUNT_GROUPS_GETALL_FAILURE',

  GET_REQUEST: 'DISCOUNT_GROUPS_GET_REQUEST',
  GET_SUCCESS: 'DISCOUNT_GROUPS_GET_SUCCESS',
  GET_FAILURE: 'DISCOUNT_GROUPS_GET_FAILURE',

  ADD_REQUEST: 'DISCOUNT_GROUPS_ADD_REQUEST',
  ADD_SUCCESS: 'DISCOUNT_GROUPS_ADD_SUCCESS',
  ADD_FAILURE: 'DISCOUNT_GROUPS_ADD_FAILURE',

  UPDATE_REQUEST: 'DISCOUNT_GROUPS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'DISCOUNT_GROUPS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'DISCOUNT_GROUPS_UPDATE_FAILURE',
}